import { Card, CardContent } from "./ui/card";

export function StatCard({ title, value, icon: Icon, color }) {
    return (
        <Card className="border-slate-200 shadow-sm">
            <CardContent className="p-4 flex items-center justify-between">
                <div>
                    <p className="text-xs font-medium text-slate-500 uppercase tracking-wide">{title}</p>
                    <div className="text-2xl font-bold text-slate-900 mt-1">{value}</div>
                </div>
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${color}`}>
                    <Icon className="w-5 h-5" />
                </div>
            </CardContent>
        </Card>
    );
}
